import Badge from './ant';

export default Badge;
